import { createComponent } from '@lit-labs/react';
import React from 'react';
import { OmniSearchElement, OmniTableElement, OmniTileElement, 
              OmniStyleElement, OmniToolbarElement, OmniIconElement,  
              OmniLoadingIndicatorElement, OmniTooltipElement, 
              OmniSwitchElement, OmniCheckbox, OmniRangeSlider } from 'omni-ui';
import {OmniCalendar} from 'omni-ui/omni-calendar.js';
 
import { Om2IconMenu } from "omni-campaign-ui";
import { OmniDropdown } from 'omni-ui';
import { OmniTableSticky } from 'omni-ui/omni-table-sticky.js';
import { OmniTooltipNext } from 'omni-ui/omni-tooltip-next.js';
import { LitVirtualizer } from '@lit-labs/virtualizer'; // Import the Lit Virtualizer element
import { OmniFileUpload } from 'omni-ui/omni-file-upload.js';
export const OmniDropdownComponent = createComponent(
  React,
  'omni-dropdown',
  OmniDropdown,
  {
    onDropdownChange: 'change',
    onDropdownClick: 'click'
  },
);

export const OmniSearchComponent = createComponent(
  React,
  'omni-search',
  OmniSearchElement,
  {
    onSearchUpdate: 'search-update'
  }
);

export const OmniTableComponent = createComponent(
    React,
    'omni-table',
    OmniTableElement,
    {
      onSortUpdate: 'sort',
      onExpandOrCollapse: 'expand-or-collapse-rows'
    }
  );

  export const OmniTableStickyComponent = createComponent(
    React,
    'omni-table-sticky',
    OmniTableSticky,
    {
      onSortUpdate: 'sort',
      onExpandOrCollapse: 'expand-or-collapse-rows'
    }
  );

  export const OmniTileComponent = createComponent(
    React,
    'omni-tile',
    OmniTileElement
  );

  export const OmniStyleComponent = createComponent(
    React,
    'omni-style',
    OmniStyleElement
  );

  export const OmniToolbarComponent = createComponent(
    React,
    'omni-toolbar',
    OmniToolbarElement
  );

  export const OmniIconComponent = createComponent(
    React,
    'omni-icon',
    OmniIconElement
  );

  export const OmniLoadingIndicatorComponent = createComponent(
    React,
    'omni-loading-indicator',
    OmniLoadingIndicatorElement
  );

  export const OmniIconMenu = createComponent(
    React,
    'om2-icon-menu',
    Om2IconMenu,
    {
      onDropdownChange: 'change'
    }
  );

  export const OmniTooltipComponent = createComponent(
    React,
    'omni-tooltip',
    OmniTooltipElement
  );

  export const OmniTooltipNextComponent = createComponent(
    React,
    'omni-tooltip-next',
    OmniTooltipNext
  );

  export const OmniSwitchComponent = createComponent(
    React,
    'omni-switch',
    OmniSwitchElement,
    {
      onSwitchChange: 'change',
    }
  );

  export const OmniCheckboxComponent = createComponent(
    React,
    'omni-checkbox',
    OmniCheckbox,
    {
      onCheckboxChange: 'change',
    }
  );
  export const OmniRangeSliderComponent = createComponent(
    React,
    'omni-range-slider',
    OmniRangeSlider,
    {
      onRangeSliderChange: 'change',
    }
  );

  export const LitVirtualizerComponent = createComponent(
    React,
    'lit-virtualizer',
    LitVirtualizer
  );

  export const OmniFileUploadComponent = createComponent(
    React,
    'omni-file-upload',
    OmniFileUpload
  );

  export const OmniCalendarComponent = createComponent(
    React,
    'omni-calendar',
    OmniCalendar,
    {
      onCalendarChange: 'change',
    }
  );
